import ValidatedForm, { FormReadiness, SubmitButton } from '../forms/ValidatedForm';
import FieldLabel, { RequiredFieldsNote } from '../forms/FieldLabel';
import { LOCAL_PREVIEW } from '../../localPreview';
import { AdminThemeToggle } from './adminTheme';

export default function AdminLogin({ busy, onSubmit, status, theme, onToggleTheme }) {
  return (
    <main className="admin-page admin-login-page" data-theme={theme}>
      <ValidatedForm className="admin-login" showFeedbackOnSubmit onSubmit={onSubmit}>
        <p className="admin-kicker">Website management</p>
        <h1>Admin login</h1>
        {LOCAL_PREVIEW && <p>Local account: <strong>admin@local.test</strong><br />Password: <strong>local-preview-only</strong></p>}
        <p className="admin-login-intro">Sign in to update site content, audience data, and approved media.</p>
        <RequiredFieldsNote />
        <FieldLabel>Email<input name="email" type="email" autoComplete="username" required /></FieldLabel>
        <FieldLabel>Password<input name="password" type="password" autoComplete="current-password" required /></FieldLabel>
        {status.message && <p className={`admin-message ${status.type}`} role="alert">{status.message}</p>}
        <FormReadiness /><SubmitButton className="admin-primary" disabled={busy} data-busy={busy}>
          {busy ? "Signing in…" : "Sign in"}
        </SubmitButton>
        <a className="admin-back-link" href="/">← Return to website</a>
        <div className="admin-login-theme"><AdminThemeToggle theme={theme} onToggle={onToggleTheme} /></div>
      </ValidatedForm>
    </main>
  );
}
